import React, { useEffect, useState } from 'react';
import { TextField, styled, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CustomTooltip from '../CustomTooltip';

const TextFieldContainer = styled('div')(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    'height': 'calc(var(--fs-xl)*2.35) !important',
    borderRadius: 'calc(var(--sp-xxs)*2)'
  }
}));

const Search = ({ placeholder, setQuery, value = '', sx = {}, tooltip = '' }) => {
  const [searchQuery, setSearchQuery] = useState(value);
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    setSearchQuery(value);
  }, [value]);

  //debounce : search after 500ms of typing
  const handleSearchChange = (e) => {
    clearInterval(searchTimeout);
    if (e.target.value.trimStart().length > 0) {
      setSearchTimeout(
        setTimeout(() => {
          setQuery(e.target.value.trimStart());
        }, 500)
      );
    }
    if (!e.target.value) {
      setSearchTimeout(
        setTimeout(() => {
          setQuery(e.target.value.trimStart());
        }, 500)
      );
    }
    setSearchQuery(e.target.value.trimStart());
  };

  return (
    <TextFieldContainer>
        <CustomTooltip title={tooltip} arrow placement="right">
        <TextField
          style={{ background: 'white'}}
          size="small"
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: <SearchIcon sx={{ fontSize: 'calc(var(--fs-xl)*1.2)' }} />,
          }}
        sx={[
          {
            '& .MuiOutlinedInput-root': {
              borderRadius: 'var(--sp-md)',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: 'var(--sp-md)',
            },
          },
          sx,
        ]}
      />
      </CustomTooltip>
    </TextFieldContainer>
  );
};

export default Search;
